import React from 'react';
import { Stack, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';

const AccountActionButtons = ({ row, onEdit, onView, canEdit }) => {
  const isPending = row.verificationStatus === 0;

  return (
    <Stack direction="row" spacing={1}>
      {isPending && canEdit ? (
        <Tooltip title="Edit Status">
          <IconButton color="primary" onClick={() => onEdit(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="View Status">
          <IconButton color="primary" onClick={() => onView(row)}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};

export default AccountActionButtons;
